import {ShowerHeadTypes, ShowerHandTypes, createParentPositions} from "../../constants";
import ShowerCommon from "../showerNew/showerCommon";

export default class HandShowerKit extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hand_shower_kit';
    this.partName = 'Hand Shower Kit';
    this.translateId = "visualizer.bathroom.shower.hand_shower_kit";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (!Array.isArray(dbFeature.metaData["MountType"])) {
      dbFeature.metaData["MountType"] = ["0"]
    }
    return super.load(dbFeature);
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_fixture);
    showerParent.setShowerHandType(ShowerHandTypes.hand_shower_kit);
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return (showerParent.shower_head_type !== ShowerHeadTypes.shower_arm
        && showerParent.shower_head_type !== ShowerHeadTypes.shower_fixture)
      || showerParent.shower_hand_type !== ShowerHandTypes.hand_shower_kit
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    //Hand Shower Kit should be displayed with the fixtures that have MountType: 0
    if (showerParent.showerFixture && !showerParent.showerFixture.disabled && showerParent.showerFixture.activeFeature
      && showerParent.showerFixture.activeFeature.metaData["MountType"]) {
      conditions.push({
        propName: "MountType",
        propValue: showerParent.showerFixture.activeFeature.metaData["MountType"]
      })
    }
    return conditions
  }

  canDisplayDemoPoint() {
    return this.getParent().shower_head_type !== ShowerHeadTypes.shower_head_bundle
  }

  showLayerPositionsModal() {
    return true
  }

}
